import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { Link } from 'react-router';

interface Props {
  title: string;
  link: string;
}

const ExternalLink = ({ title, link }: Props) => {
  return (
    <Link to={link} reloadDocument target='_blank' rel='noreferrer' className={'salv-external-link'}>
      <span>{title}</span>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className={'m-l-4'} />{' '}
    </Link>
  );
};

export default ExternalLink;
